import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { PreloadAllModules, Route } from '@angular/router';
import { Observable, fromEvent, merge, of } from 'rxjs';
import { first, mapTo, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InteractionBasedPreloadingStrategy extends PreloadAllModules {
    private userInteracted = false;
    private platformId = inject(PLATFORM_ID);
    private readonly userInteractions$!: Observable<any>;

    constructor() {
        super();
        if (isPlatformBrowser(this.platformId)) {
            this.userInteractions$ = merge(
                fromEvent(document, 'click'),
                fromEvent(document, 'keydown'),
                fromEvent(document, 'scroll'),
                fromEvent(document, 'mousemove'),
                fromEvent(document, 'touchstart')
            ).pipe(
                first(),
                mapTo(true)
            );
        }
    }

    override preload(route: Route, load: () => Observable<any>): Observable<any> {
        if (isPlatformServer(this.platformId)) {
            return of(null);
        }
        // If user has already interacted, preload immediately
        if (this.userInteracted) {
            return super.preload(route, load);
        }

        // Wait for first user interaction before preloading
        return this.userInteractions$.pipe(
            switchMap(() => {
                this.userInteracted = true;
                return super.preload(route, load);
            })
        );
    }
}